export class TrackingEventInfoModel {
  trackingCategory: string;
  trackingLabel: string;

  constructor(trackingCategory: string, trackingLabel: string) {
    this.trackingCategory = trackingCategory;
    this.trackingLabel = trackingLabel;
  }
}

export class GtmOrderModel {
  customer_id: string;
  order_id: string;
  product_array: GtmOrderProductModel[];
}

export class GtmOrderProductModel {
  category: string;
  id: string;
  name: string;
  option_name: string;
  price: number;
  quantity: number;
  status: string; // 'on'/'off'
}

export class GtmCustomerModel {
  VKFE_FIXED: string;
  address: GtmAddressModel;
  contact: GtmContactModel;
  customerId: string;
  customerIdHashed: string;
  isAgent: boolean;
  isFmcCustomer: boolean;
  privacy: GtmPrivacyModel;
  products: GtmProductsViewModel;
}

export class GtmAddressModel {
  city: string;
  fullAddress: string;
  fullAddressHashed: string;
  number: number; // eslint-disable-line id-blacklist
  numberExtension: string;
  numberExtensionHashed: string;
  numberHashed: string;
  street: string;
  zipcode: string;
  zipcodeHashed: string;
}

export class GtmContactModel {
  email: string;
  emailHashed: string;
  telephoneNumber: string;
  telephoneNumberHashed: string;
}

export class GtmPrivacyModel {
  offers: PrivacyChannels;
  research: PrivacyChannels;
}

export class PrivacyChannels {
  email: boolean;
  letters: boolean;
  sms: boolean;
  telemarketing: boolean;
}

export class GtmProductsViewModel {
  internetProducts: GtmProduct[];
  tvProducts: GtmProduct[];
  voipProducts: GtmProduct[];
}

export class GtmProduct {
  name: string;
  price: number;
  startdate: string;
}
